import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { X, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  const failedAttempts = ['Las vacaciones de una semana no funcionan porque te llevas la carga mental en la maleta.', "Los decretos de 'soy una reina' fallan porque tu sistema nervioso sigue sintiéndose en peligro si no tiene el control.", 'Intentar delegar te estresa más porque sientes que los demás no lo harán con tu nivel de excelencia.', 'La terapia convencional no ha logrado que tu cuerpo aprenda a relajarse de verdad.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 bg-brown text-cream relative overflow-hidden" data-id="element-171">
      {/* Decorative background */}
      <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-brown-light/20 blur-3xl" data-id="element-172" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-173">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-174">
          {/* Why it didn't work */}
          <div data-id="element-175">
            <FadeIn data-id="element-176">
              <h2 className="text-3xl md:text-4xl font-serif mb-8 text-gold" data-id="element-177">
                Por qué lo que has intentado no funciona
              </h2>
            </FadeIn>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-50px'
          }} className="space-y-6" data-id="element-178">
              {failedAttempts.map((attempt, index) => <motion.li key={index} variants={itemVariants} className="flex items-start" data-id="element-179">
                  <div className="flex-shrink-0 mt-1 mr-4 bg-brown-light/50 p-1 rounded-full" data-id="element-180">
                    <X className="w-5 h-5 text-rose-light" data-id="element-181" />
                  </div>
                  <p className="text-lg text-cream/80 leading-relaxed" data-id="element-182">
                    {attempt}
                  </p>
                </motion.li>)}
            </motion.ul>
          </div>

          {/* The Unique Mechanism */}
          <div data-id="element-183">
            <FadeIn delay={0.2} data-id="element-184">
              <div className="bg-cream text-brown p-8 md:p-10 rounded-3xl shadow-2xl" data-id="element-185">
                <div className="flex items-center justify-center w-16 h-16 bg-gold/20 rounded-full mb-6" data-id="element-186">
                  <Sparkles className="w-8 h-8 text-gold-dark" data-id="element-187" />
                </div>
                <h3 className="text-2xl md:text-3xl font-serif mb-4" data-id="element-188">
                  El Secreto: <br data-id="element-189" />
                  <span className="text-gold-dark" data-id="element-190">
                    La Suavidad Estratégica
                  </span>
                </h3>
                <div className="space-y-4 text-lg text-brown/80" data-id="element-191">
                  <p data-id="element-192">
                    No se trata de ser débil o sumisa; se trata de aprender a
                    desmantelar la armadura de supervivencia para activar tu
                    magnetismo natural.
                  </p>
                  <p data-id="element-193">
                    Este programa te enseña a transicionar biológicamente del
                    modo <strong data-id="element-194">Cortisol (lucha)</strong> al modo{' '}
                    <strong data-id="element-195">Oxitocina (recepción)</strong>.
                  </p>
                  <p className="font-serif text-xl text-brown italic pt-4 border-t border-gold/30" data-id="element-196">
                    Permitiendo que el mundo empiece a trabajar para ti, y no tú
                    para el mundo.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}